import { render, staticRenderFns } from "./project-sites.vue?vue&type=template&id=bbfe0384&scoped=true"
import script from "./project-sites.vue?vue&type=script&lang=js"
export * from "./project-sites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfe0384",
  null
  
)

export default component.exports